<div
  class="mx-auto flex w-[17rem] cursor-pointer flex-col transition-all hover:-translate-y-2 hover:duration-500 md:w-[14rem]"
  *ngIf="post.user.name">
  <div class="header flex justify-between gap-2">
    <div class="flex flex-1 flex-col truncate">
      <span class="text-lg font-semibold text-primary-darkest line-clamp-1">{{
        post.user.name
      }}</span>
      <span class="-mt-1 text-xs text-primary-darkest">{{
        post.created_at | date: 'dd-MM-yyyy'
      }}</span>
    </div>
    <!-- like comment share component -->
    <div class="flex gap-4">
      <div class="space-x-1">
        <fa-icon [icon]="faHeart" class="text-secondary-dark"></fa-icon>
        <span class="font-semibold text-primary-darkest">{{
          post.total_likes
        }}</span>
      </div>
      <div class="space-x-1">
        <fa-icon [icon]="faComment" class="text-primary-md-dark"></fa-icon>
        <span class="font-semibold text-primary-darkest">{{
          post.total_comments
        }}</span>
      </div>
      <!-- <div class="space-x-1">
        <fa-icon [icon]="faShare" class="text-gray-400"></fa-icon>
      </div> -->
    </div>
    <!-- end like comment share component -->
  </div>
  <div class="image relative mt-3">
    <img
      [routerLink]="'/beautybook/detail/' + post.id"
      class="h-64 w-64 rounded-r-full rounded-b-full border-2 border-primary-dark object-fill md:h-[14rem] md:w-[14rem]"
      [src]="post.path"
      [alt]="post.post_products[0].beautybook_post_product_name" />

    <div class="absolute right-0 bottom-1">
      <div
        [routerLink]="[
          '/beautybook/add',
          post.post_products[0].beauty_book_product_id
        ]"
        class="hover: flex h-16 w-16 cursor-pointer items-center justify-center rounded-full border-primary-md-dark bg-primary-md-dark text-center font-bold text-white hover:border-2 hover:bg-white hover:text-primary-md-dark">
        <div class="px-2 text-sm uppercase">Try On</div>
      </div>
    </div>
  </div>
  <div class="product mt-3 flex">
    <ng-container
      *ngIf="post.post_products[0].beauty_book_product_variant_name">
      <img
        class="h-16 w-16"
        [src]="
          post.post_products[0].beauty_book_product_variant_path.small.path
        "
        [alt]="post.post_products[0].beauty_book_product_variant_name" />
      <div class="info">
        <div
          class="variant w-fit rounded-l-full rounded-r-full bg-primary-md-dark px-3 py-1 text-xs text-white">
          {{ post.post_products[0].beauty_book_product_variant_name }}
        </div>
        <div class="caption mt-0.5 h-10 text-sm line-clamp-2">
          {{ post.caption }}
        </div>
      </div>
    </ng-container>
    <ng-container
      *ngIf="!post.post_products[0].beauty_book_product_variant_name">
      <img
        class="h-16 w-16"
        [src]="post.post_products[0].beauty_book_product_path.small.path"
        [alt]="post.post_products[0].beauty_book_product_name" />
      <div class="info">
        <div
          class="variant w-fit rounded-l-full rounded-r-full bg-primary-md-dark px-3 py-1 text-xs text-white">
          {{ post.post_products[0].beauty_book_product_name }}
        </div>
        <div class="caption mt-0.5 h-10 text-sm line-clamp-2">
          {{ post.caption }}
        </div>
      </div>
    </ng-container>
  </div>
</div>
